export default __webpack_public_path__ + "static/media/y.fc6cb69a.mp4";